<template><div><h1 id="adressbereinigung-automatisch" tabindex="-1"><a class="header-anchor" href="#adressbereinigung-automatisch"><span>Adressbereinigung automatisch</span></a></h1>
<p>Adressbereinigung automatisch — Führt eine automatische Adressbereinigung durch</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Mit diesem Programm können die eigenen Adressen mit einer beliebigen Personenquelle automatisch abgeglichen, sprich veredelt werden. Die Personenquelle muss vorgängig in funtrade eingelesen werden, siehe <RouteLink to="/referenz/refs/ft.refproc.adrimp.html" title="Adressimport verarbeiten...">Adressimport in eigene / Fremd-Datenbank</RouteLink>.</p>
<h2 id="start-parameter" tabindex="-1"><a class="header-anchor" href="#start-parameter"><span>Start &amp; Parameter</span></a></h2>
<p>Pfad: Adressen → Datenpflege → Adressbereinigung → Adressbereinigung automatisch</p>
<p><strong>Parameter</strong></p>
<dl>
<dt>Personenquelle</dt>
<dd>Auswahl der Personenquelle mit der die Adressen abgeglichen werden.</dd>
<dt>Adressen nach Filter</dt>
<dd>Auswahl des Adressfilters. Der Abgleich beschränkt sich nur auf die Adressen, die sich im ausgewählten Filter befinden.</dd>
<dt>Zu bereinigende Adressen</dt>
<dd>Mit dieser Einstellung wird definiert, ob nur die postalisch falschen Adressen bereinigt werden, oder alle Adressen.</dd>
<dt>Zu bereinigende Daten</dt>
<dd>Hier wird definiert, welche Adressdaten bereinigt/veredelt werden. Folgende Möglichkeiten stehen zur Auswahl:
<table>
<thead>
<tr>
<th>Auswahl</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>komplette Adressdaten</td>
<td>Alle möglichen Adressdaten wie Vorname, Nachname, Firma, Adresszusatz, Strasse, Hausnummer, Postleitzahl, Ort, Tel., Fax., E-Mail, etc. werden abgeglichen.</td>
</tr>
<tr>
<td>Name</td>
<td>Es werden nur Adressdaten wie Vorname, Nachname, Firma oder Adresszusatz abgeglichen.</td>
</tr>
<tr>
<td>postalische Daten</td>
<td>Es werden nur die postalischen Daten wie Strasse, Hausnummer, Postleitzahl oder Ort abgeglichen.</td>
</tr>
<tr>
<td>Telekommunikationsdaten</td>
<td>Es werden nur die Telekommunikationsdaten wie Tel., Fax. oder E-Mail abgeglichen.</td>
</tr>
</tbody>
</table>
</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Protokoll vom Abgleich.</p>
<h2 id="welche-daten-werden-verwendet-input" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verwendet-input"><span>Welche Daten werden verwendet? (Input)</span></a></h2>
<p>Fremdadressen</p>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<p>Adressdaten an eigenen Adressen.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refproc.abglkandsuchen.html" title="Abgleichskandidaten suchen">Abgleichskandidaten suchen</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.abglkandmanbearb.html" title="Abgleichskandidaten manuell bearbeiten">Abgleichskandidaten manuell bearbeiten</RouteLink></p>
</div></template>


